module.exports = __webpack_public_path__ + "static/tap-dancing-to-work-e43e9241e206ed09c673959f26901f2b.jpg";